import { MFChannel } from '../../../Components/SDK';
import { setTotalRecords } from '../../../Slice';
import Store from '../../../Store';

// Commented out — channel/activity API is not in use
// export const fetchInvitationCount = async () => {
//    try {
//       const response = await MFChannel.fetchChannelInvitationList({
//          createdAt: 0,
//          size: 1,
//       });
//       const pendingRecords = response?.data?.pendingRecords || 0;
//       Store.dispatch(setTotalRecords(pendingRecords));
//       return pendingRecords;
//    } catch (error) {
//       return;
//    }
// };
export const fetchInvitationCount = async () => {
   return 0;
};

export const handleIconTabUnreadChannel = async () => {
   fetchInvitationCount();
};
